import React from 'react';
import { Form, Row, Col, InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

const PricingForm = ({ register, errors, watch }) => {
  const pricingOption = watch('pricingOption');
  return (
    <>
      <Row className="mb-3 g-3">
        <Form.Group as={Col} xs="auto">
          <Form.Select
            {...register('pricingOption', {
              required: 'You must select an option.'
            })}
            isInvalid={errors.pricingOption}
          >
            <option value="">Select pricing option</option>
            <option value="TOTAL_ASKING_PRICE">Total asking price</option>
            <option value="ASKING_PRICE_PER_HECTARE">
              Asking price per hectare
            </option>
            <option value="MAKE_AN_OFFER">Make an offer</option>
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errors.pricingOption?.message}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} xs="auto">
          <InputGroup className="mb-2">
            <InputGroup.Text>$</InputGroup.Text>
            <Form.Control
              {...register('price', {
                required: [
                  'TOTAL_ASKING_PRICE',
                  'ASKING_PRICE_PER_HECTARE'
                ].includes(pricingOption)
                  ? 'You must specify an amount.'
                  : false
              })}
              isInvalid={errors.price}
              disabled={
                !['TOTAL_ASKING_PRICE', 'ASKING_PRICE_PER_HECTARE'].includes(
                  pricingOption
                )
              }
            />
          </InputGroup>
          <Form.Control.Feedback type="invalid">
            {errors.price?.message}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
    </>
  );
};

PricingForm.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  watch: PropTypes.func.isRequired
};

export default PricingForm;
